/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpBackend } from "@angular/common/http";
import { API_PATH } from "../../environments/config";
@Injectable({
  providedIn: "root",
})
export class BusinessService {
  currentBusinessUnitData;
  httpWithoutInterceptor: HttpClient;
  companyConfig;
  selectedMatTab;
  constructor(private http: HttpClient, private httpBackend: HttpBackend) {
    this.httpWithoutInterceptor = new HttpClient(httpBackend);
  }
  getLocationBusinessUnit(coords, distance) {
    let httpParams = new HttpParams();
    httpParams = httpParams
      .set("latitude", coords.latitude)
      .set("longitude", coords.longitude);
    if (distance) {
      httpParams = httpParams.set("distance", distance);
    }
    if (coords.company) {
      httpParams = httpParams.set("company", coords.company);
    }
    if (coords.isPickUp) {
      httpParams = httpParams.set("isPickUp", coords.isPickUp);
    }
    // if(window.location.hostname.startsWith('srsm') || window.location.href.startsWith('srshopping')){
    //    httpParams = httpParams.set('code','SR');
    // }
    return this.http.get(API_PATH.apis.locationBusinessUnits, {
      params: httpParams,
    });
  }
  getGeoCodeAddress(url) {
    return this.httpWithoutInterceptor.get(url);
  }
}
